import axios from 'axios';
import authService from './authService'; // authService 임포트

const axiosInstance = axios.create({
    baseURL: 'https://jtc-admin.ddns.net/api',
    //baseURL: 'http://localhost:8080/api',
    // baseURL:'http://192.168.0.53:3000/api',
    headers: {
        'Content-Type': 'application/json',
    },
});

// 요청 인터셉터: 모든 요청에 액세스 토큰 추가
axiosInstance.interceptors.request.use(
    (config) => {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 응답 인터셉터: 401 에러 발생 시 토큰 갱신 시도
axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;
        
        // 401 에러이고, 이미 재시도한 요청이 아니며, 로그인/리프레시 토큰 요청이 아닌 경우
        if (error.response.status === 401 && !originalRequest._retry && originalRequest.url !== '/login' && originalRequest.url !== '/refresh-token') {
            originalRequest._retry = true; // 재시도 플래그 설정
            
            // console.log("액세스 토큰 만료 (401 에러). 토큰 갱신을 시작합니다.");

            try {
                const refreshToken = localStorage.getItem('refreshToken');
                if (refreshToken) {
                    // console.log("리프레시 토큰으로 새로운 액세스 토큰을 요청합니다.");
                    const response = await authService.refreshToken(refreshToken);
                    
                    const newAccessToken = response.data.accessToken;
                    const newRefreshToken = response.data.refreshToken;

                    localStorage.setItem('accessToken', newAccessToken);
                    if (newRefreshToken) {
                        localStorage.setItem('refreshToken', newRefreshToken);
                    }

                    // console.log("토큰 갱신 성공! 새로운 액세스 토큰으로 이전 요청을 재시도합니다.");
                    originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                    return axiosInstance(originalRequest);
                } else {
                    // console.log("리프레시 토큰이 없어 로그인 페이지로 이동합니다.");
                    window.location.href = '/login';
                }
            } catch (refreshError) {
                console.error("토큰 갱신 실패. 로그인 페이지로 이동합니다.", refreshError);
                // 리프레시 토큰 갱신 실패 시 모든 토큰 정보 삭제 후 로그인 페이지로 이동
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                localStorage.removeItem('user_details');
                window.location.href = '/login';
                return Promise.reject(refreshError);
            }
        }
        
        // 403 에러도 로그인 페이지로 리다이렉트하도록 추가
        if (error.response.status === 403 && originalRequest.url !== '/login') {
            console.error("403 Forbidden 에러. 권한이 없습니다. 로그인 페이지로 이동합니다.");
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('user_details');
            window.location.href = '/login';
            return Promise.reject(error);
        }
        
        return Promise.reject(error);
    }
);

export default axiosInstance;
